<template>
    <ul v-if="checkedCategories.length" class="list-selected">
        <li v-for="category in checkedCategories">
            {{ resolveCategoryName(category) }}
            <a href="#" @click.prevent="$emit('remove-category', category.id)">usuń</a>
        </li>
    </ul>
</template>

<script>
    import CategoryNameResolver from "../mixins/CategoryNameResolver";

    export default {
        name: "ItemSelected",
        mixins: [
            CategoryNameResolver
        ],
        props: {
            checkedCategories: {
                type: Array,
                default: () => [],
            },
        },
    }
</script>

<style scoped lang="scss">

    ul.list-selected {

        margin: 0;
        padding: 20px;

        & li {
            font-size: 14px;
            list-style-type: none;
            margin: 0;
            padding: 0;

            & a {
                float: right;
                color: #BF2F00;
                font-style: normal;
            }
        }
    }

</style>
